<template>
  <component
    :is="component"
    v-bind="currentProperties"
    v-on="currentListeners"
  />
</template>

<script setup lang="ts">
import { PropType, computed } from "vue";
import CertificationResultCard from "@/components/v2/search-page-results/CertificationResultCard.vue";
import DisbursementResultCard from "@/components/v2/search-page-results/DisbursementResultCard.vue";
import { CertificationSearchResultModel } from "@/types/certifications";
import { DisbursementSearchResultModel } from "@/types/disbursements";

const props = defineProps({
  pageName: {
    type: String,
    default: "",
  },
  result: {
    type: Object as PropType<
      CertificationSearchResultModel | DisbursementSearchResultModel
    >,
    required: true,
  },
});

const component = computed(() => {
  switch (props.pageName.toLowerCase()) {
    case "certifications":
      return CertificationResultCard;
    case "disbursements":
      return DisbursementResultCard;
    default:
      return undefined;
  }
});

const currentProperties = computed(() => {
  switch (component.value) {
    case CertificationResultCard:
      return { certification: props.result };

    case DisbursementResultCard:
      return { disbursement: props.result };
    default:
      return {};
  }
});

const currentListeners = computed(() => {
  return {};
});
</script>